import './css/styles.scss';

function initLasMer() {
    
    const blocks = document.querySelectorAll(".las-mer-block");

    blocks.forEach(block => {
        const container = block.querySelector(".acf-innerblocks-container");
        const button = block.querySelector(".las-mer-toggle");
        const span = button?.querySelector("span");

        if (!container || !button) return;

        // Start collapsed
        //container.style.display = "none";

        button.addEventListener("click", () => {
            const expanded = block.classList.toggle("expanded");

            if (expanded) {
                //container.style.display = "block";
                //button.textContent = "Visa mindre -";
                span!.textContent = " - ";
                button.setAttribute("aria-expanded", "true");
            } else {
                //container.style.display = "none";
                //button.textContent = "Visa mer +";
                span!.textContent = " + ";
                button.setAttribute("aria-expanded", "false");
            }
        });
    });
};

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	initLasMer();
});

